import { combineReducers } from 'redux';
import _ from 'lodash';

import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATE_ITEMS,
} from 'src/api';

import {
  FETCH_MESSAGES_START,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAILURE,
} from './actions';

const transformMessage = response => {
  return {
    id: response.id,
    isFromFI: response.message_from_fi,
    text: response.message_message,
    userFirstName: response.message_user.user_first_name,
    userLastName: response.message_user.user_last_name,
    userEmail: response.message_user.user_email_address,
    messageWasRead: response.message_was_read,
  };
};

const transformMessages = response => {
  return {
    _paging: response.paging,
    items: response.map(transformMessage),
  };
};

const fetchMessagesReducer = createApiReducer(
  [FETCH_MESSAGES_START, FETCH_MESSAGES_SUCCESS, FETCH_MESSAGES_FAILURE],
  transformMessages,
  error => _.get(error, 'payload.response', 'unknown error')
);

export const messages = chainReducers(
  INITIAL_API_STATE_ITEMS,
  fetchMessagesReducer
);

export const reducer = combineReducers({
  messages,
});
